import { Arrival as Line } from '@beyond-js/ui';
import { Arrival, productNames, type FamilyProductId } from '@beyond-js/ui/react';
import { useSearchParams } from 'react-router-dom';
import { useDocs } from '@cdn/docs';
import { useI18n } from '@cdn/i18n';
import { useSession } from '@cdn/identity';

/**
 * The arrival line of a page another product opened (`?from=<product>`, decision D54): "Opened from Projects ·
 * Back to Projects", the first line of the page. Its address comes from this deployment's configuration and
 * reopens the place in view there (the project, or the organization), never from the link; a product this
 * deployment names no address of gets no line. Dismissing it takes `from` out of the address.
 */
export function Way() {
	const { locale } = useI18n();
	const docs = useDocs();
	const session = useSession();
	const [search, setSearch] = useSearchParams();
	const from = search.get('from') ?? '';
	const name = productNames[from as FamilyProductId];
	const href = name && docs.back(from, { project: search.get('project') ?? undefined, organization: session.organization?.organization });
	if (!href) return null;

	const dismiss = () =>
		setSearch(
			current => {
				const next = new URLSearchParams(current);
				next.delete('from');
				return next;
			},
			{ replace: true }
		);
	return (
		<Arrival
			product={name}
			href={href}
			labels={Line.labels[locale.code === 'es' ? 'es' : 'en']}
			onDismiss={dismiss}
		/>
	);
}
